// Réexporte la spécification graphique partagée (cf. CLAUDE.md §2).
// Toute couleur de graphique vient d'ici — jamais d'une valeur en dur.
// L'attribut d'import est exigé par Node dès qu'un test remonte jusqu'ici
// par la chaîne des imports ; Vite le comprend aussi.
import palette from "../../partage/palette.json" with { type: "json" };

export type NiveauMaitrise = "non_acquis" | "en_cours" | "fragile" | "acquis";

export const couleursNiveaux = palette.niveaux_maitrise;
export const libellesNiveaux = palette.libelles_niveaux;
export const seuilsNiveaux = palette.seuils_niveaux;
export const couleursExercices = palette.categorielle_exercices.couleurs;
export const sequentielle = palette.sequentielle;
export const neutres = palette.neutres;
export const miseEnEvidence = palette.mise_en_evidence;
export const marques = palette.marques;
export const validation = palette.validation;

// Teintes de fond de la grille de saisie. L'export xlsx lit les mêmes :
// une couleur définie ici, jamais dans une feuille de style.
const fondsNotes = palette.fonds_notes as Record<string, string>;

/** Fond d'une cellule de saisie. `undefined` pour une question non corrigée. */
export function fondNote(valeur: number | undefined): string | undefined {
  return valeur === undefined ? undefined : fondsNotes[String(valeur)];
}

/** Niveau de maîtrise correspondant à un taux de réussite (0 à 1). */
export function niveauPourTaux(taux: number): NiveauMaitrise {
  if (taux >= seuilsNiveaux.acquis) return "acquis";
  if (taux >= seuilsNiveaux.fragile) return "fragile";
  if (taux >= seuilsNiveaux.en_cours) return "en_cours";
  return "non_acquis";
}

/**
 * Couleur d'un exercice par son rang (1-indexé).
 *
 * L'ordre des teintes est fixe : c'est lui qui garantit la lisibilité des
 * paires voisines, y compris pour les daltonismes. Ne jamais le réordonner.
 */
export function couleurExercice(numero: number): string {
  return couleursExercices[(numero - 1) % couleursExercices.length];
}

export default palette;
